import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

const root = document.getElementById('root')
if (!root) throw new Error('APL Connect V7 root element is missing.')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
